<template>
    <div class="square_body">
        <div class="w">
            <HeadNav activeIndex="4" ></HeadNav>
        </div>
		<!-- 按钮 -->
        <div class="banner_square">
			<div class="banner_square_button">
				<el-button type="primary" class="square_button" @click="square_button">发布项目到广场</el-button>
			</div>
        </div>
		
		<div class="w_x"> 
			<div class="w_square">
				<span class="w_square_left">广场项目</span>
				<span class="w_square_right">
					<input type="text" placeholder="请输入问卷标题">
					<el-button>我参与的</el-button>
					<el-button>我发布的</el-button>
				</span>
				
			</div>
			
			<div class="square" v-for="item in squareList" :key="item.id">
				<div class="squareList_left">
					<p><span v-show="state == 2">我的</span>{{item.wjTitle }}</p>
					<p><i>-</i><span>{{item.participateNum}} 人参与</span> <i>-</i><span>{{item.issueTime}}前发布</span></p>
						
				</div>
				<el-button class="squareList_right">立即参与</el-button>
			</div>
			<!-- 分页 -->
			<div class="block">
			  <el-pagination
			        @size-change="handleSizeChange"
			        @current-change="handleCurrentChange"
			        :current-page.sync="currentPage3"
			        :page-size="pageSize"
			        layout="prev, pager, next, jumper"
			        :total="total">
			      </el-pagination>
			</div>
			 <div style="width: 100%; height: 71px; background-color:#F7F7F7;"></div>
		</div>
		
		<!-- 模态框 -->
		<div v-if="setSquare" class="setSquare"></div>
		<div class="sendSquare" v-if="setSquare">
			<p>我的项目 <i class="el-icon-close"></i></p>
			<div v-for="item in squareList" :key="item.id">
				<p>
					<span v-show="state == 2">广场</span>
					<span>{{item.wjTitle}}      </span>	
					<span>{{item.participateNum}} </span> 
					<span>{{item.issueTime}}前发布</span>
				</p>
			</div>
		</div>
    </div>
</template>

<script>
import HeadNav from "@/components/HeadNav";
export default {
	components: {
		HeadNav,
	},
	data() {
		return {
			currentPage3: 1,
			squareList:[],
			state:1, //是否是我发布的问卷
			pageSize:14,//分页一页显示
			total:0,
			// setSquare:true,
			projectList:[],
		}
	},
	
	mounted: function() {
		
	},
	methods: {
		square_button(){},
		// 分页
		handleSizeChange(val) {
		    console.log(`每页 ${val} 条`);
		},
		handleCurrentChange(val) {
		    console.log(`当前页: ${val}`);
		},
		loadSetAnswer(){
			let that = this;
			let params = {
			    that: this,
			    url: this.$config.service.SetAnswerPlaza,
			    data: {
					
				},
			    cb(res) {
			        if (res.code == 0) {
			         console.log(res)
			        }else {

			            that.$message.error(res.message);
			        }
					
			    }
			}
			this.$util.request(params);
		},
		loadSquare(){
		    let that = this;
			 // let id = createId
		    let params = {
		        that: this,
		        url: this.$config.service.queryAnswerPlaza,
		        data: {
					 "id":"1265674573036478466",
					 "ifanswerPlaza": 1
				},
		        cb(res) {
		            if (res.code == 0) {
		                // requestUtil
		             that.squareList= res.resultBody.datas;
		             console.log(that.squareList)
		            }else {
		                that.squareList = [];
		                that.$message.error(res.message);
		            }
		
		        }
		    }
		    this.$util.request(params);
		},
	},
	created() {
	    this.loadSquare()
		this.loadSetAnswer()
	},
};
</script>
<style scoped  lang="scss">
	.square_body{
		background-color: #F7F7F7;
			// 轮播图
			.banner_square {
				height:550px;
				width: 100%;
				background: url("../assets/banner_square.png") no-repeat center;	
				.banner_square_button{
					width: 1200px;
					margin: 0 auto;
					.square_button{
						font-family:Microsoft YaHei;
						margin-top: 394px;
					}
				}
			}
		// 广场项目
		.w_x{
			width: 1200px;
			max-height: 1530px;
			margin:0 auto;
			background-color: #fff;
			// 广场项目
			.w_square{
				height:115px;
				background-color:#F7F7F7;
				line-height: 115px;
				.w_square_left{
					width: 78px;
					height: 20px;
					font-size: 20px;
					text-align: center;
					font-family:Microsoft YaHei;
				}
				.w_square_right{
					float: right;
					input{
						width: 260px;
						height: 32px;
						margin-right: 15px;
					}
					el-button{
						width: 90px;
						height: 32px;
						border-radius: 4px;
						color: #0080FF;
						font-size: 14px;
						font-family:Microsoft YaHei;
					}
				}
			}
			// 内容
			.square{
				width: 1160px;
				height: 100px;
				margin-top: 30px;
				margin: 0 auto;

				border-bottom:1px solid #CCCCCC;
				display: flex;
				justify-content: space-between;
				.squareList_left{
					margin-top: 30px;
					p:nth-child(1){
						font-size: 16px;
						font-family:Microsoft YaHei;
						color:#333;
						margin-bottom: 21px;
						span{
							width: 32px;
							height: 20px;
							border: 1px solid #0080FF;
							font-size: 12px;
							color: #0080FF;
							margin-right: 10px;
							padding:1px 5px;
						}
						&:hover{
							color: #0080ff;
							cursor:pointer;
						}
					}
					
					p:nth-child(2){
						font-size: 12px;
						color:#666;
						font-family:Microsoft YaHei;
					}
				}
				.squareList_right{
					// width: 92px;
					height:32px;
					line-height: 7px;
					text-align: center;
					margin-top: 30px;
					border-radius:4px ;

				}
			}
			// 分页
			.block{
				width: 1160px;
				height: 116px;
				
				text-align: center;
				.el-pagination{
					line-height: 116px;
					vertical-align:bottom;
				}
			}
		}
		// 模态框
		.setSquare {
		  position: fixed;
		  left: 0;
		  top: 0;
		  z-index: 1001;
		  width: 100%;
		  height: 100%;
		  background-color: #000;
		  opacity: 0.3;
		}
		/* 短信确认发送遮罩层 */
		.sendSquare {
			position: fixed;
			background: #fff;
			width: 900px;
			min-height: 610px;
			overflow: auto;
			opacity: 1;
			z-index: 2001;
			top: 20%; /*偏移*/
			left: 50%;
			margin-left: -450px;
			p{
				height: 56px;
				border-bottom: 1px solid #0080FF;
				font-size: 18px;
				color:#333;
				text-align:center;
				line-height: 56px;
				i{
					float:right;
					line-height: 56px;
					margin-right:20px;
				}
				
			}
		}
	}
			
</style>